export interface BreadCrumbType {
  breadcrumbs?: { label: string; link?: string }[]
}
export const getBreadCrumbSchema = ({
  breadcrumbs,
  resolvedUrl,
}: {
  breadcrumbs: BreadCrumbType['breadcrumbs']
  resolvedUrl: string
}) => {
  if (!breadcrumbs?.length) {
    return {}
  }
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.map((item, idx: number) => {
      return {
        '@type': 'ListItem',
        position: idx + 1,
        name: item.label,
        item: breadcrumbs.length - 1 === idx ? resolvedUrl : item.link,
      }
    }),
  }
}
